export function toggle<T extends string>(list: T[], code: T, max?: number): T[] {
  if (list.includes(code)) return list.filter((c) => c !== code)
  if (max !== undefined && list.length >= max) return list
  return [...list, code]
}
